import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchFirebaseMessageList(filter) {
  return request({
    url: '/api/firebase_messages',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createFirebaseMessage(data) {
  if (data['debug']) {
    return request({
      url: '/api/firebase_messages/sendMessageByDebugFirebase',
      method: 'post',
      params: {
        'access_token': getToken()
      },
      data
    })
  } else {
    return request({
      url: '/api/firebase_messages/sendMessageByFirebase',
      method: 'post',
      params: {
        'access_token': getToken()
      },
      data
    })
  }
}



